export enum ClientLinks {
  GetOngoingOnboardingFile = "getOngoingOnboardingFile",
  UpdateEmailAddress = "updateEmailAddress",
}
